import React from "react";

const multiFormContext = React.createContext({  });
export default multiFormContext;
